import * as React from 'react';
import * as classnames from 'classnames/bind';

const styles = require('./TextRun.less');
const cx = classnames.bind(styles);

export interface TextRunProps
{
    className?:string;
}

export class TextRun extends React.Component<TextRunProps,any>
{
    render()
    {
        let {className} = this.props;

        return <span className={cx('text-run', className)}>
                    {this.props.children}
               </span>;
    }
}